import React from 'react';
import PropTypes from 'prop-types';
import urlPropType from 'url-prop-type';
import cn from 'classnames';

export const ButtonColors = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};

export const ButtonLinkTargets = {
  BLANK: '_blank',
  SELF: '_self',
  parent: '_parent',
  TOP: '_top'
};

export const ButtonSizes = {
  SM: 'sm',
  MD: 'md'
};

export const ButtonTypes = {
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset'
};

export const ButtonVariants = {
  CONTAINED: 'contained',
  TEXT: 'text'
};

const Button = React.forwardRef(
  ({
    ariaLabel,
    children,
    className,
    color,
    disabled,
    link,
    linkTarget,
    name,
    size,
    text,
    textUnderline,
    type,
    variant,
    ...props
  }, ref) => {
    const baseClass = 'otrl-jp__button';
    const classes = cn(baseClass, {
      [`${baseClass}--disabled`]: disabled,
      [`${baseClass}--secondary`]: color === ButtonColors.SECONDARY,
      [`${baseClass}--sm`]: size === 'sm',
      [`${baseClass}--text`]: variant === ButtonVariants.TEXT,
      [`${baseClass}--text-underline`]: variant === ButtonVariants.TEXT && textUnderline
    }, className);

    const Tag = link ? 'a' : 'button';
    
    return (
      <Tag
        aria-label={ariaLabel}
        className={classes}
        disabled={disabled}
        href={link}
        name={name}
        ref={ref}
        target={link && linkTarget}
        type={!link ? type : undefined}
        {...props}
      >
        {children || text}
      </Tag>
    );
  }
);

Button.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.oneOf(Object.values(ButtonColors)),
  disabled: PropTypes.bool,
  link: urlPropType,
  linkTarget: PropTypes.oneOf(Object.values(ButtonLinkTargets)),
  name: PropTypes.string,
  size: PropTypes.oneOf(Object.values(ButtonSizes)),
  text: PropTypes.string,
  textUnderline: PropTypes.bool,
  type: PropTypes.oneOf(Object.values(ButtonTypes)),
  variant: PropTypes.oneOf(Object.values(ButtonVariants))
};

Button.defaultProps = {
  ariaLabel: null,
  className: null,
  color: ButtonColors.PRIMARY,
  disabled: false,
  link: null,
  linkTarget: null,
  name: null,
  size: 'md',
  text: '',
  textUnderline: false,
  type: ButtonTypes.BUTTON,
  variant: ButtonVariants.CONTAINED
};

export default Button;
